var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "text-center py-5" },
    [
      _vm.icon
        ? _c("font-awesome-icon", {
            staticClass: "mb-3 text-muted",
            attrs: { icon: _vm.icon, size: "3x" },
          })
        : _vm._e(),
      _vm.title
        ? _c("h4", { staticClass: "mb-2" }, [_vm._v(_vm._s(_vm.title))])
        : _vm._e(),
      _vm.description
        ? _c("p", { staticClass: "text-muted mb-4" }, [
            _vm._v(_vm._s(_vm.description)),
          ])
        : _vm._e(),
      _vm._t("action", function () {
        return [
          _vm.buttonText
            ? [
                _vm.buttonLink
                  ? _c(
                      "a",
                      _vm._b(
                        {
                          staticClass: "btn btn-primary btn-lg",
                          attrs: { href: _vm.buttonLink },
                        },
                        "a",
                        _vm.buttonDataAttributes,
                        false
                      ),
                      [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]
                    )
                  : _c(
                      "button",
                      _vm._b(
                        {
                          staticClass: "btn btn-primary btn-lg",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("action")
                            },
                          },
                        },
                        "button",
                        _vm.buttonDataAttributes,
                        false
                      ),
                      [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]
                    ),
              ]
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }